<template>
	<div class="extend-page">
		<v-card v-if="item">
			<v-container>
				<v-layout align-center justify-space-between wrap class="mb-2">
					<h2 class="title">{{ item.title }}</h2>
					<navigation :id="item.id" />
				</v-layout>
				<p class="body-1">Hinweis: {{ item.text }}</p>
				<commence-date @save="save"></commence-date>
				<router-link
					:to="{ name: 'page', params: { id: 888 } }"
					class="v-btn v-btn--depressed v-btn--small theme--light primary"
					:id="`p${item.id}-t888`"
				>
					Weiss nicht
				</router-link>
			</v-container>
		</v-card>
	</div>
</template>

<script>
import CommenceDate from './CommenceDate.vue';
import Navigation from './Navigation.vue';

export default {
	props: ['item'],
	components: {
		CommenceDate,
		Navigation,
	},
	computed: {
		low() {
			return this.item.options.find(o => o.label === 'lt6months');
		},
		high() {
			return this.item.options.find(o => o.label === 'gte6months');
		},
	},
	methods: {
		save(commicementgt6months) {
			const { target } = commicementgt6months ? this.high : this.low;
			this.$router.push({ name: 'page', params: { id: target } });
		},
	},
};
</script>
